import { TransportMode } from '../models/transport-mode.enum';
import { TranslationService } from '../services/translation.service';

const translationDictionary = [
  { transportMode: TransportMode.bus, translationKey: 'common.bus' },
  { transportMode: TransportMode.ferry, translationKey: 'common.ferry' },
  { transportMode: TransportMode.train, translationKey: 'common.train' },
  { transportMode: TransportMode.tram, translationKey: 'common.tram' },
  { transportMode: TransportMode.taxi, translationKey: 'common.taxi' },
  { transportMode: TransportMode.walk, translationKey: 'common.transportmodes.walk' },
  { transportMode: TransportMode.bike, translationKey: 'common.bike' },
  // NV - 5212 - Buss on demand should be removed when trial period is over
  { transportMode: TransportMode.bussondemand, translationKey: 'common.bussondemand' },
];

export class TransportModeHelper {
  public static parse(value: string): TransportMode {
    if (Object.values(TransportMode).includes(value as TransportMode)) {
      return value as TransportMode;
    }
    return TransportMode.unknown;
  }

  public static translate(transportMode: string): string {
    if (!transportMode) {
      return '';
    }
    if (translationDictionary.findIndex((obj) => obj.transportMode === transportMode) < 0) {
      return transportMode;
    }

    let result = '';
    const translationKeyValue = translationDictionary.find((obj) => obj.transportMode === transportMode);
    if (translationKeyValue) {
      result = TranslationService.get(translationKeyValue.translationKey);
    }

    return result;
  }

  public static getSortIndexForTransportMode(tm: TransportMode): number {
    const sortValues = {
      [TransportMode.tram]: 0,
      [TransportMode.ferry]: 1,
      [TransportMode.train]: 2,
      [TransportMode.bus]: 3,
      [TransportMode.taxi]: 4,
      [TransportMode.walk]: 4,
      [TransportMode.bike]: 4,
      [TransportMode.car]: 4,
      [TransportMode.bussondemand]: 4,
      [TransportMode.none]: 99,
      [TransportMode.unknown]: 99,
    };
    return sortValues[tm];
  }
}
